import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteProgram = (ProgramID) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.DELTE_PROGRAM(ProgramID)
  );
};

export default deleteProgram;
